<template>
    <div>
        <div class="card">
            <div class="card-header">Medical Record Sharing Consent</div>
            <div class="card-body">
                <div ref="tableSection">
                    <table ref="listTable" class="table table-hover">
                        <col width="50">
                        <col>
                        <col width="200">
                        <col width="200">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Full Name</th>
                                <th scope="col">Identity Number</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-show="guardianList.length === 0">
                                <td :colspan="columnsCount" class="text-center font-italic">
                                    {{isTableLoading ? "Loading Data": "No Data"}}
                                </td>
                            </tr>
                            <tr v-for="(guardian, index) in guardianList" :key="index">
                                <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                                <td>{{guardian.name}}</td>
                                <td>{{guardian.identityNumber}}</td>
                                <td>
                                    <button v-if="guardian.status == 1"
                                        class="btn btn-primary btn-sm btn-primary-insv mr-2"
                                    @click="approveGuardian(guardian.guardianId)">
                                        Approve
                                    </button>
                                    <button
                                        class="btn btn-danger btn-sm"
                                        @click="rejectGuardian(guardian.guardianId)">
                                        Reject
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- <pagination v-model="pagination.currentPage"
                    :totalPages="pagination.totalPages"
                    :scrollPosition="pagination.scrollPosition">
                </pagination> -->
            </div>
        </div>
        <popup-modal ref="popupUpdateSuccessful" :hasCloseButton="false" title="Permission Update">
            <template slot="content">
                <p>{{message}}</p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissPopupSuccessful">Okay</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import 'daterangepicker/daterangepicker';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'GuardianPermission',
    'components': {
        popupModal
    },
    data () {
        return {
            'columnsCount': 4,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'guardianList': [],
            'message': ''
        };
    },
    mounted () {
        this.getGuardianList();
    },
    'methods': {
        validateForm () {
            return this.$validator.validateAll();
        },
        getGuardianList () {
            this.axios.post('UserDependent/GetGuardianList', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({ data }) => {
                let guardianData = data.data;

                if (guardianData != null) {
                    this.isTableLoading = false;
                    let pagedResult = data.data;

                    this.pagination.currentPage = pagedResult.p;
                    this.pagination.totalPages = pagedResult.c;

                    let list = pagedResult.l;

                    this.guardianList = list.map((guardian) => ({
                        'guardianId': guardian.gci,
                        'name': guardian.fn,
                        'identityNumber': guardian.in,
                        'status': guardian.s
                    }));
                }
            });
        },
        approveGuardian (guardianId) {
            this.message = 'Updating your preference. Please wait...';
            this.$refs.popupUpdateSuccessful.show();

            this.axios.get('UserDependent/ApproveGuardianPermission', {
                'params': {
                    'guardianConsentId': guardianId
                }
            }).then(({ data }) => {
                this.message = 'Permission updated successfully!';
                this.getGuardianList();
            }).catch(() => {
                this.message = 'Error updating your preference. Please try again.';
                // this.getConsentConsultations();
            });
        },
        rejectGuardian (guardianId) {
            this.message = 'Updating your preference. Please wait...';
            this.$refs.popupUpdateSuccessful.show();

            this.axios.get('UserDependent/RejectGuardianPermission', {
                'params': {
                    'guardianConsentId': guardianId
                }
            }).then(() => {
                this.message = 'Permission updated successfully!';
                this.getGuardianList();
            }).catch(() => {
                this.message = 'Error updating your preference. Please try again.';
            });
        },
        dismissPopupSuccessful () {
            this.$refs.popupUpdateSuccessful.hide();
        }
    }
};
</script>
